<template>
  <article
    class="bg-white border border-l-4 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow text-left"
    :class="isAdminRow ? 'border-l-blue-600' : 'border-l-gray-200'"
  >
    <div class="flex items-start gap-3">
      <peer-avatar :user="avatarUser" size="lg" />
      <div class="flex-1 min-w-0 text-left">
        <div class="flex items-start justify-between gap-2">
          <div class="min-w-0">
            <h3 class="font-semibold text-gray-900 truncate text-left">{{ displayName }}</h3>
            <p class="text-sm text-gray-500 truncate text-left">{{ user.email }}</p>
          </div>
          <span
            class="px-2 py-1 rounded-full text-[11px] font-semibold shrink-0"
            :class="isAdminRow ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-600'"
          >
            {{ isAdminRow ? 'Admin' : 'Student' }}
          </span>
        </div>
        <p v-if="facultyText" class="mt-2 text-sm text-gray-700 truncate text-left">{{ facultyText }}</p>
        <p class="text-xs text-gray-500 truncate text-left">Registered {{ user.registrationDateShort || 'N/A' }}</p>
      </div>
    </div>

    <div class="mt-4">
      <span v-if="isSelf" class="block text-center px-3 py-2 rounded-lg bg-gray-50 text-gray-400 text-sm font-medium">
        This is you
      </span>
      <button
        v-else
        type="button"
        class="w-full px-3 py-2 rounded-lg text-sm font-semibold inline-flex items-center justify-center gap-1.5 transition-colors"
        :class="isAdminRow ? 'bg-red-50 text-red-700 hover:bg-red-100' : 'bg-blue-100 text-blue-800 hover:bg-blue-200'"
        @click="$emit('toggle-role', user)"
      >
        <span class="material-symbols-outlined text-base">{{ isAdminRow ? 'remove_moderator' : 'add_moderator' }}</span>
        <span>{{ isAdminRow ? 'Remove Admin' : 'Make Admin' }}</span>
      </button>
    </div>
  </article>
</template>

<script>
import PeerAvatar from '@/components/socials/PeerAvatar.vue';

export default {
  name: 'AdminUserCard',
  components: { PeerAvatar },
  props: {
    user: {
      type: Object,
      required: true
    },
    isSelf: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-role'],
  computed: {
    isAdminRow() {
      return this.user.role === 'admin';
    },
    displayName() {
      const fullName = `${this.user.name || ''} ${this.user.surname || ''}`.trim();
      return fullName || 'Unnamed';
    },
    avatarUser() {
      return { name: this.displayName, profilePicture: this.user.profilePicture };
    },
    facultyText() {
      return this.user.university?.faculty || this.user.university?.name || '';
    }
  }
};
</script>
